"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accAdd = accAdd;
exports.arrayKeys = arrayKeys;
exports.bMapTransQQMap = bMapTransQQMap;
exports.checkHid = checkHid;
exports.checkRoles = checkRoles;
exports.colorPalette = colorPalette;
exports.copyText = copyText;
exports.countPer = countPer;
exports.dealPhone = dealPhone;
exports.delComma = delComma;
exports.formErrow = formErrow;
exports.formatTime = formatTime;
exports.outTab = outTab;
exports.param2Obj = param2Obj;
exports.parseTime = parseTime;
exports.pick = pick;
exports.pickKeys = pickKeys;
exports.qqMapTransBMap = qqMapTransBMap;
exports.setRem = setRem;
exports.showPercent = showPercent;
exports.swapItems = swapItems;
exports.todays = todays;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _auth = require("./auth");
var _segments = require("qrcode/lib/core/segments");
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if ((0, _typeof2.default)(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}
function todays(addtime) {
  var start_time = Date.now();
  var end_time = new Date(parseInt(addtime) * 1000);
  var days = start_time - end_time;
  var day = parseInt(days / (1000 * 60 * 60 * 24));
  return day;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * @param {Object} obj
 * @param {Object} arr
 * @returns {Object}
 */
function pick(obj, arr) {
  return arr.reduce(function (iter, val) {
    return val in obj && (iter[val] = obj[val]), iter;
  }, {});
}

/**
 * @param {Array} roles 需要校验的角色key
 * @returns {Boole}
 */
function checkRoles() {
  var roles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return roles.indexOf(agentInfo.level_key) > -1;
}

/**
 * @param {string} roles 需要校验的权限
 * @returns {Boole}
 */
function checkHid(roles) {
  var service = (0, _auth.getPermission)('server_permission_menus');
  // console.log(service.menus)
  return !!service.includes(roles);
}
/**
 * 自适应布局
 */
function setRem() {
  var base = 10;
  var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  var htmlDom = document.getElementsByTagName('html')[0];
  if (htmlWidth > 1280) {
    htmlWidth = 750;
  } else if (htmlWidth > 750) {
    htmlWidth = 750;
    base = 12;
  } else {
    base = 7.5;
  }
  htmlDom.style.fontSize = htmlWidth / base + 'px';
}

/**
 * @param {String} text 复制的内容
 * @param {String} msg 提示内容
 */
function copyText(text) {
  var aux = document.createElement("input");
  aux.setAttribute("value", text);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  document.body.removeChild(aux);
}
function outTab(tabId) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';
  var fix = document.querySelector('.el-table__fixed-right') ? document.querySelector('.el-table__fixed-right') : document.querySelector('.el-table__fixed');
  var xlsxParam = {
    raw: true
  };
  var wb;
  if (fix) {
    wb = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)).removeChild(fix), xlsxParam);
    document.querySelector("#".concat(tabId)).appendChild(fix);
  } else {
    wb = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)), xlsxParam);
  }

  /* get binary string as output */
  var wbout = _xlsx.default.write(wb, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  });
  try {
    _fileSaver.default.saveAs(new Blob([wbout], {
      type: 'application/octet-stream'
    }), "".concat(fileName, ".xlsx"));
  } catch (e) {
    if (typeof console !== 'undefined') console.log(e, wbout);
  }
  return wbout;
}

/**
 * @param {Objct} object 表达检验滚动到错误位置
 */
function formErrow(object) {
  for (var i in object) {
    var dom = this.$refs[i];
    if (Object.prototype.toString.call(dom) !== '[object Object]') dom = dom[0];
    //第一种方法（包含动画效果）
    dom.$el.scrollIntoView({
      //滚动到指定节点
      block: 'center',
      //值有start,center,end，nearest，当前显示在视图区域中间
      behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
    });
    break;
  }
}

/**
 * 千分位逗号去除
 */
function delComma(num) {
  if (!num) return 0;
  return parseFloat(num.toString().replace(/,/g, ''));
}

/**
 * 计算百分比
 */
function countPer(num, total) {
  if (!num || !total) return 0;
  num = parseFloat(num.toString().replace(/[^\d\.-]/g, ''));
  if (typeof total === 'string') {
    total = total.trim().toString();
    if (total.length == 0) {
      total = 0;
    } else {
      total = delComma(total);
    }
  }
  if (isNaN(num) || isNaN(total)) return 0;
  return total <= 0 ? 0 : Math.round(num / total * 10000) / 100.00;
}

/**
 * 图表设备颜色值
 */
function colorPalette() {
  return {
    0: '#2ec7c9',
    1: '#b6a2de',
    2: '#5ab1ef',
    3: '#ffb980',
    4: '#d87a80',
    5: '#8d98b3',
    6: '#e5cf0d',
    7: '#97b552',
    8: '#95706d',
    9: '#dc69aa',
    10: '#07a2a4',
    11: '#9a7fd1',
    12: '#588dd5',
    13: '#f5994e',
    14: '#c05050',
    15: '#59678c',
    16: '#c9ab00',
    17: '#7eb00a',
    18: '#6f5553',
    19: '#c14089'
  };
}

/**
 * 提取二维数组指定key
 */
function arrayKeys() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var nkey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!key) return nkey ? {} : [];
  var arr = nkey ? {} : [];
  array.map(function (item) {
    if (nkey) arr[nkey] = item[key];
    if (!nkey) arr.push(item[key]);
  });
  return arr;
}

/**
 * 取对象的指定属性
 */
function pickKeys() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var iter = {};
  for (var i in arr) {
    if (obj[arr[i]] != undefined) iter[arr[i]] = obj[arr[i]];
  }
  return iter;
}

/**
 * 分成是否一致
 */
function showPercent(profit_info, key) {
  if (profit_info[key + '_relative_divide'] != 0 && !profit_info[key + '_relative_divide']) return '0%';
  return (profit_info[key + '_relative_divide'] == 1 ? profit_info[key + '_relative_percent'] : profit_info[key + '_percent']) + '%(' + (profit_info[key + '_relative_divide'] == 1 ? '虚拟' : '真实') + ')';
}

/**
 * 百度经纬度转腾讯
 * @param lng
 * @param lat
 * @returns {{lng: number, lat: number}}
 */
function bMapTransQQMap(lng, lat) {
  var x_pi = Math.PI * 3000.0 / 180.0;
  var x = lng - 0.0065;
  var y = lat - 0.006;
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
  var lngs = z * Math.cos(theta);
  var lats = z * Math.sin(theta);
  return {
    lng: lngs,
    lat: lats
  };
}
;

/**
 * 腾讯经纬度转百度
 * @param lng
 * @param lat
 * @returns {{lng: number, lat: number}}
 */
function qqMapTransBMap(lng, lat) {
  var x_pi = Math.PI * 3000.0 / 180.0; //Math.PI ~ 3.14159265358979324
  var x = lng;
  var y = lat;
  var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
  var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
  var lngs = z * Math.cos(theta) + 0.0065;
  var lats = z * Math.sin(theta) + 0.006;
  return {
    lng: lngs,
    lat: lats
  };
}
;

/**
 * 数组元素前移后移
 * @param {Object} arr
 * @param {Object} index1
 * @param {Object} index2
 */
function swapItems(arr, index1, index2) {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0];
  return arr;
}

/**
 * 浮点数加法
 */
function accAdd() {
  var args = arguments,
    lens = args.length,
    d = 0,
    sum = 0;
  for (var key in args) {
    var str = "" + args[key];
    if (str.indexOf(".") != -1) {
      var temp = str.split(".")[1].length;
      d = d < temp ? temp : d;
    }
  }

  //计算需要乘的数值
  var m = Math.pow(10, d);

  //遍历所有参数并相加
  for (var key in args) {
    sum += args[key] * m;
  }
  return sum / m;
}

/**
 * 浮点数加法
 */
function dealPhone(tel) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
  var symbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '****';
  if (!tel) return tel;
  tel = '' + tel;
  return tel.replace(tel.substring(start, end), symbol);
}